import { scaleThreshold } from 'd3-scale'

/** Use a threshold scale in order to categorise the difference */
export const comparisonScale = scaleThreshold<number, string>()
  .domain([-0.5, -0.1, 0.1, 0.5])
  .range(['lotLess', 'less', 'same', 'more', 'lotMore'])
